import Splide from '@splidejs/splide';

Drupal.behaviors.bannerslider = {
  attach() {
    const sliders = document.querySelectorAll('.banner-carousel');
    sliders.forEach((slider) => {
      if (!slider.classList.contains('banner-carousel--processed')) {
        const splide = new Splide(slider, {
          type: 'slide',
          arrows: true,
          pagination: true,
          autoplay: false,
          perPage: 1,
          perMove: 1,
          speed: 1000,
          interval: 5000,
          rewind: false,
          gap: 2
        });
        splide.mount();
        slider.classList.add('banner-carousel--processed');
      }
    });

    if(jQuery('.cta_banner_without_padding').length){
      jQuery('.cta_banner_without_padding').closest('.layout').addClass('cta_banner_without_padding_wrapper');
      if(jQuery('.cta_banner_without_padding').closest('.banner-carousel')){
        jQuery('.cta_banner_without_padding').closest('.banner-carousel').addClass('banner-carousel_without_padding_wrapper');
      }
    }
   
    if(jQuery('.cta_banner_with_padding').length){
      jQuery('.cta_banner_with_padding').closest('.layout').addClass('cta_banner_with_padding_wrapper');
    }

    if(jQuery('.banner_with_fullwidth_bg').length){
      jQuery('.banner_with_fullwidth_bg').closest('.layout').addClass('banner_with_fullwidth_bg_wrapper');
      jQuery('.banner_with_fullwidth_bg').closest('.banner-carousel').addClass('banner-carousel_fullwidth_bg');
    }

    if(jQuery('.banner-carousel--processed').length){
      jQuery('.banner-carousel--processed').closest('.layout').addClass('banner-carousel--processed_wrapper');
    }
  },
};
